import React from 'react';
import { IChildConnectionDTO } from '../../../../../../api/connections.dao';
import TextWithCopyBtn from '../../connections-list/_text-with-copy-btn/text-with-copy-btn';
import { childConnectionDetailsLabels } from '../../../../../../constants/connections-labels.constants';

type PanelistLinkDetailsProps = {
    childConnection: IChildConnectionDTO;
    onCopyBtnClick: () => void;
};

export const PanelistLinkDetails = (props: PanelistLinkDetailsProps): JSX.Element => {
    const { childConnection, onCopyBtnClick } = props;
    const { attendeeId, attendeeEmail, connectionLink, participantId, connectionId } = childConnection;
    const labels = childConnectionDetailsLabels();

    return (
        <>
            {connectionLink && (
                <div className='connection-list__field'>
                    {labels.CONNECTION_LINK()}:<br />
                    <TextWithCopyBtn message={connectionLink} handleCopyClick={onCopyBtnClick} />
                </div>
            )}
            {participantId && (
                <div className='connection-list__field'>
                    {labels.PARTICIPANT_ID()}:<br />
                    <TextWithCopyBtn message={participantId} handleCopyClick={onCopyBtnClick} />
                </div>
            )}
            {attendeeId && (
                <div className='connection-list__field'>
                    {labels.ATTENDEE_ID()}:<br />
                    <TextWithCopyBtn message={String(attendeeId)} handleCopyClick={onCopyBtnClick} />
                </div>
            )}
            {attendeeEmail && (
                <div className='connection-list__field'>
                    {labels.ATTENDEE_EMAIL()}:<br />
                    <TextWithCopyBtn message={attendeeEmail} handleCopyClick={onCopyBtnClick} />
                </div>
            )}
            {connectionId && (
                <div className='connection-list__field'>
                    {labels.WEBINAR_ID()}:<br />
                    <TextWithCopyBtn message={connectionId} handleCopyClick={onCopyBtnClick} />
                </div>
            )}
        </>
    );
};